var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-fullheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{},[_c('p',{staticClass:"title"},[_vm._v("404 Page Not Found")]),_c('router-link',{staticClass:"is-primary button",attrs:{"to":"/"}},[_vm._v("Home")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }